import TabbedPane from './TabbedPane'

export default {
  name: 'tabbed-pane',
  configure: function(config) {
    config.addComponent('tabbed-pane', TabbedPane)
  }
}
